import httpService from "@/utils/services/http_service";

export default {
    /**
     * @author: lafitewu
     * date: 2020-04-13
     *  管理员列表
     */

    //  短信发送任务列表
    async smsList(data={}) {
      return httpService.post(
        '/api.php?do=admin_sms_task_list',
        data
      )
    },

    //  用户组列表
    async userList(data={}) {
      return httpService.post(
        '/api.php?do=admin_client_group_list',
        data
      )
    },

    //  新增信息
    async smsAdd(data={}) {
      return httpService.post(
        '/api.php?do=admin_sms_task_add',
        data
      )
    },

    //  信息删除
    async deleteFn(data={}) {
      return httpService.post(
        '/api.php?do=admin_sms_task_delete',
        data
      )
    },

    //  编辑信息详情
    async editInfo(data={}) {
      return httpService.post(
        '/api.php?do=admin_sms_task_info',
        data
      )
    },

    //  编辑保存
    async editSave(data={}) {
      return httpService.post(
        '/api.php?do=admin_sms_task_edit',
        data
      )
    },
}